import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

// Los campos salen del tema (MuiOutlinedInput, 40 px); aquí solo el ancho, el separador y el
// botón de recargar, que va con el mismo borde que los inputs.
const DateRangeStyled = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }

  .date-field {
    width: 170px;

    .MuiOutlinedInput-adornedEnd {
      padding-right: 4px;
    }
  }

  .separator {
    flex-shrink: 0;
  }

  .submit {
    width: 40px;
    height: 40px;
    margin-left: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${color.text.secondary};
    background: ${color.background.default};
    border: 1.5px solid ${color.border.default};
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.2s ease;

    :hover {
      border-color: ${props => props.theme.primary || color.brand.primary};
    }

    :focus {
      outline: 0;
    }

    :disabled {
      cursor: default;
    }
  }

  .rotate svg {
    animation: spinner 0.6s linear infinite;
  }
`

export default DateRangeStyled
